import {ClientStateContextSearchDetailGateway} from "./clientstatecontextSearchDetail.gateway";
import {ClientStateContextSearchDetailViewModel} from "./clientstatecontextSearchDetail.viewmodel";
import {IClientStateContextSearchDetailParams} from "./clientStateContextSearchDetailParams";

export class ClientStateContextSearchDetailController {

    private clientStateContextSearchDetailViewModel:ClientStateContextSearchDetailViewModel;

    static $inject = ['$stateParams','clientStateContextSearchDetail.gateway'];

    constructor(private $stateParams: IClientStateContextSearchDetailParams, private clientStateContextSearchDetailGateway:ClientStateContextSearchDetailGateway)
    {
        this.clientStateContextSearchDetailViewModel = new ClientStateContextSearchDetailViewModel();
        this.activate();
    }

    private activate(){

        return this.clientStateContextSearchDetailGateway.loadClientStateContextSearchDetailViewModel(this.$stateParams.clientStateContextId)
            .then((viewModel: ClientStateContextSearchDetailViewModel) => {
                this.clientStateContextSearchDetailViewModel = viewModel;
            });
    }
}